import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./BookingHistorySection')));

const BookingHistoryRoutes = [
	{ path: '/dashboard/bookinghistory', element: <Analytics />, auth: authRoles.admin },
];

export default BookingHistoryRoutes;
